<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<ng-scrollbar
  class="cancellation-view-wrapper view-with-static-right-sidebar ps container"
  [ngClass]="{ 'sidebar-opened': activitiesService.isOpened }"
  orientation="vertical"
  #perfectScroll
>
  <app-side-button
    [icon]="'far fa-history'"
    [customClasses]="'btn-activity-floating'"
    (click)="openActivities()"
    *ngIf="!activitiesService.isOpened && hotelBookingCancellationId"
  ></app-side-button>

  <div class="d-flex justify-content-between booking-cancellation-wrapper">
    <div>
      <h5 class="title-secondary mt-0" *ngIf="data?.id && !data?.finished">
        {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.EDIT_CANCELLATION' | translate }}
        #{{ data?.id }}
      </h5>
      <h5 class="title-secondary mt-0" *ngIf="!data?.id">
        {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.ADD_CANCELLATION' | translate }}
      </h5>
      <h5 class="title-secondary mt-0" *ngIf="data?.id && data?.finished">
        {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.VIEW_CANCELLATION' | translate }}
        #{{ data?.id }}
      </h5>
    </div>

    <div class="d-flex align-items-stretch">
      <app-reminder-button
        [reminderableId]="data?.id"
        [reminderableType]="LaravelModelsEnum.HOTELBOOKINGCANCELLATION"
      ></app-reminder-button>
      &nbsp;&nbsp;
      <app-download-rooming-list-button *ngIf="data?.id" [bookingId]="data?.booking?.id">
      </app-download-rooming-list-button>
    </div>
  </div>

  <hr class="mt-2 mb-0" />

  <div class="booking-wrapper booking-cancellation-wrapper">
    <div class="section-title">
      {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.HOTEL_BOOKING' | translate }}
      #{{ data?.booking?.id }}
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-12">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.HOTEL_NAME' | translate }}
            </div>
            <div class="value">{{ data?.booking?.hotel.name || '-' }}</div>
          </div>
          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.SUPPLIER_NAME' | translate }}
            </div>
            <div class="value">{{ data?.booking?.supplier?.name || '-' }}</div>
          </div>
          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.REF_NUMBER' | translate }}
            </div>
            <div class="value">{{ data?.booking?.ref_number || '-' }}</div>
          </div>
          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.COMPANY_NAME' | translate }}
            </div>
            <div class="value">{{ data?.booking?.company.shortName || '-' }}</div>
          </div>
          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.BREAKFAST' | translate }}
            </div>
            <div class="value">
              <span *ngIf="data?.booking?.breakfast">
                {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.YES' | translate }}
              </span>
              <span *ngIf="!data?.booking?.breakfast">
                {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.NO' | translate }}
              </span>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.CONTACTING_AGENT' | translate }}
            </div>
            <div class="value no-border">
              {{ data?.booking?.contracting_agent?.names || '-' }}
            </div>
          </div>

          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.RESERVATION_AGENT' | translate }}
            </div>
            <div class="value no-border">
              {{ data?.booking?.reservation_agent?.names || '-' }}
            </div>
          </div>

          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.CANCELLATION_DEADLINE' | translate }}
            </div>
            <div class="value bold highlighted no-border">
              {{ data?.booking?.cancellation_deadline | date : env.pipeDateFormat || '-' }}

              <span *ngIf="data?.booking?.cancellation_deadline">
                (
                {{
                  data?.booking?.cancellation_deadline
                    | amParse : env.apiPipeDateFormat
                    | amDifference : moment : 'days'
                }}
                {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.DAYS' | translate }}
                )
              </span>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.PAYMENT_DEADLINE' | translate }}
            </div>
            <div class="value bold highlighted no-border">
              {{ data?.booking?.payment_deadline | date : env.pipeDateFormat || '-' }}

              <span *ngIf="data?.booking?.payment_deadline">
                (
                {{ data?.booking?.payment_deadline | amParse : env.apiPipeDateFormat | amDifference : moment : 'days' }}
                {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.DAYS' | translate }}
                )
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-12">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.EVENTS' | translate }}
            </div>
            <div class="value">
              <span *ngFor="let event of data?.booking?.events; let i = index">
                <a [routerLink]="['/events/view']" [queryParams]="{ id: event?.id }"> {{ event.formattedName }}</a
                ><span *ngIf="data?.booking?.events.length !== i + 1">,</span>
              </span>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.COMMISSION' | translate }}
            </div>
            <div class="value">
              {{ data?.booking?.commission_percent || '-' }}
              <span *ngIf="data?.booking?.commission_percent"> % </span>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.CURRENCY' | translate }}
            </div>
            <div class="value bold">
              <app-currency-box [currency]="data?.booking?.currency"></app-currency-box>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="title">
              {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.NOTES' | translate }}
            </div>
            <div class="value">{{ data?.booking?.note || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div (click)="log(data)">log</div>
  <div class="title-tertiary">
    {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.ROOMS' | translate }}
  </div>
  <div class="booking-cancellation-wrapper">
  <kendo-grid [data]="data?.booking?.rooms">
    <kendo-grid-column [width]="50" class="text-center" headerClass="checkbox-header-cell">
      <ng-template kendoGridHeaderTemplate>
        <input
          type="checkbox"
          [attr.id]="'rooms-header'"
          [checked]="isAllRoomsSelected()"
          (change)="allRoomsCheckboxChange()"
          [disabled]="!data?.booking?.isSomeNightAvailable()"
        />
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <input
          type="checkbox"
          [attr.id]="'room' + rowIndex"
          [checked]="isRoomSelected(dataItem)"
          (change)="roomCheckboxChange(dataItem)"
          [disabled]="!dataItem.isRoomAvailable()"
        />
        <small>({{ roomSelectedNightsCount(dataItem) }}/{{ dataItem.nights.length }})</small>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="60"
      class="text-center"
      headerClass="text-center"
      field="id"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.ID' | translate }}"
    ></kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="type.value"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.TYPE' | translate }}"
    ></kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="check_in"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.CHECK_IN' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.check_in | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="check_out"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.CHECK_OUT' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.check_out | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="available_nights"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.AVAILABLE_NIGHTS' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.getAvailableNights() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="total_nights"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.TOTAL_NIGHTS' | translate }}"
    ></kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="min_nights"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.MIN_NIGHTS' | translate }}"
    ></kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="people"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.PEOPLE' | translate }}"
    ></kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="meal_plan.value"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.MEAL_PLAN' | translate }}"
    ></kendo-grid-column>

    <kendo-grid-column class="text-center" headerClass="text-center">
      <ng-template kendoGridHeaderTemplate let-column let-rowIndex="rowIndex">
        {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.AVG_NET_PRICE' | translate }}
        <app-currency-box [currency]="data?.booking?.currency"></app-currency-box>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.getAvgNetPrice() | number : '1.2-2' }}
        <app-currency-converter
          [fromCurrency]="data.booking.currency"
          [value]="dataItem.getAvgNetPrice()"
          class="d-block"
        >
        </app-currency-converter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column class="text-center" headerClass="text-center">
      <ng-template kendoGridHeaderTemplate let-column let-rowIndex="rowIndex">
        {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.AVG_PRICE' | translate }}
        ({{ 'DEFAULT_CURRENCY' | translate }})
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.getAvgPrice() | number : '1.2-2' }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column class="text-center" headerClass="text-center">
      <ng-template kendoGridHeaderTemplate let-column let-rowIndex="rowIndex">
        {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.AVG_MARGIN' | translate }}
        ({{ 'DEFAULT_CURRENCY' | translate }})
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.getAvgMargin() | number : '1.2-2' }}
      </ng-template>
    </kendo-grid-column>

    <div *kendoGridDetailTemplate="let dataItem">
      <kendo-grid [data]="dataItem?.nights" class="nested-kendo-grid mt-2 mb-2" [style.width.%]="100">
        <kendo-grid-column width="35" class="text-center" headerClass="nested-kendo-grid-header-cell">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <input
              type="checkbox"
              [attr.id]="'night' + rowIndex"
              [checked]="isNightSelected(dataItem.id)"
              (change)="nightCheckboxChange(dataItem.id)"
              [disabled]="!dataItem.isNightAvailable()"
            />
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          [width]="60"
          class="text-center"
          headerClass="nested-kendo-grid-header-cell text-center"
          field="id"
          title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.ID' | translate }}"
        ></kendo-grid-column>

        <kendo-grid-column
          class="text-center"
          headerClass="nested-kendo-grid-header-cell text-center"
          field="date"
          title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.DATE' | translate }}"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem?.date | date : env.pipeDateFormat }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center"
          headerClass="nested-kendo-grid-header-cell text-center"
          field="guest_names"
          title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.GUEST_NAMES' | translate }}"
        ></kendo-grid-column>

        <kendo-grid-column
          class="text-center"
          headerClass="nested-kendo-grid-header-cell text-center"
          title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.STATUS' | translate }}"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-night-status [night]="dataItem"></app-night-status>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column class="text-center" headerClass="nested-kendo-grid-header-cell text-center">
          <ng-template kendoGridHeaderTemplate let-column let-rowIndex="rowIndex">
            {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.NET_PRICE' | translate }}
            <app-currency-box [currency]="data?.booking?.currency"></app-currency-box>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem.net_price }}
            <app-currency-converter [fromCurrency]="data.booking.currency" [value]="dataItem.net_price" class="d-block">
            </app-currency-converter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column class="text-center" headerClass="nested-kendo-grid-header-cell text-center" field="price">
          <ng-template kendoGridHeaderTemplate let-column let-rowIndex="rowIndex">
            {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.PRICE' | translate }}
            ({{ 'DEFAULT_CURRENCY' | translate }})
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column class="text-center" headerClass="nested-kendo-grid-header-cell text-center" field="margin">
          <ng-template kendoGridHeaderTemplate let-column let-rowIndex="rowIndex">
            {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.MARGIN' | translate }}
            ({{ 'DEFAULT_CURRENCY' | translate }})
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem.margin | number : '1.2-2' }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center"
          headerClass="nested-kendo-grid-header-cell text-center"
          field="web_price"
        >
          <ng-template kendoGridHeaderTemplate let-column let-rowIndex="rowIndex">
            {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.WEB_PRICE' | translate }}
            ({{ 'DEFAULT_CURRENCY' | translate }})
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </kendo-grid>
  </div>
  <div class="cancellations-note-wrapper booking-cancellation-wrapper" *ngIf="data">
    <div class="form-group">
      <label>{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.NOTE' | translate }}</label>
      <textarea
        class="form-control note-textarea"
        [(ngModel)]="data.note"
        [rows]="3"
        [cols]="30"
        pInputTextarea
        autoResize="true"
      ></textarea>
    </div>
  </div>

  <div class="text-end booking-cancellation-wrapper">
    <button class="btn btn-primary" type="button" (click)="update()" *ngIf="!data?.finished">
      {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.SAVE' | translate }}
    </button>
    <button
      *ngIf="!data?.finished"
      class="btn btn-warning"
      type="button"
      [swal]="{
        titleText:
          'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.SAVE_AND_FINISH_CONFIRM_TITLE' | translate
      }"
      (confirm)="update(true)"
    >
      {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_VIEW.SAVE_AND_FINISH' | translate }}
    </button>
  </div>
</ng-scrollbar>
